/**
 * @generated SignedSource<<c896458132eccadac44e3b4ad8fb4652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClientContactInput = {
  id: string;
  clientId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteClientContactMutation$variables = {
  input: DeleteClientContactInput;
};
export type DeleteClientContactMutation$data = {
  readonly deleteClientContact: {
    readonly deletedClientContactId: string | null;
    readonly client: {
      readonly id: string;
      readonly primaryContactId: string | null;
    } | null;
  } | null;
};
export type DeleteClientContactMutation = {
  variables: DeleteClientContactMutation$variables;
  response: DeleteClientContactMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientContactPayload",
    "kind": "LinkedField",
    "name": "deleteClientContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedClientContactId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Client",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryContactId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteClientContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteClientContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d45730a8ae0d969b6b7f596e201f341",
    "id": null,
    "metadata": {},
    "name": "DeleteClientContactMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteClientContactMutation(\n  $input: DeleteClientContactInput!\n) {\n  deleteClientContact(input: $input) {\n    deletedClientContactId\n    client {\n      id\n      primaryContactId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "987fd4dd25e4a96cdeecf59210139c86";

export default node;
